import { Helmet } from 'react-helmet';
import { useDispatch, useSelector } from 'react-redux';
import { Alert, Box, Container, Grid, Modal, Snackbar } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import AddIcon from '@mui/icons-material/Add';
import { useEffect, useState } from 'react';

import customParseFormat from 'dayjs/plugin/customParseFormat';
import GymCard from 'src/components/dashboard/GymCard';
import { commonReducerAction } from 'src/redux/reducers/common';
import './style.css';
import AddGymModal from 'src/components/member/Modals/addGymModal';
import EditGymModal from 'src/components/member/Modals/editModalGym';
import ConfirmDialog from 'src/components/ConfirmationBox';
import { deleteGym, getProfile } from 'src/api/batches';
import { CONSTANTS } from 'src/commons';
import { logoutUser, startLoading, stopLoading } from 'src/redux/actions';

const Gym = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { setGymId, updateUserCredentials } = commonReducerAction;
  const [deleteModal, setDeleteModal] = useState(false);

  const { user, gymId } = useSelector((state) => state.common);
  const [allGyms, setAllGyms] = useState();
  dayjs.extend(customParseFormat);
  const [open, setOpen] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const handleClose = () => setOpen(false);
  const handleCloseEditModal = () => setOpenEditModal(false);
  const [gymInfo, setGymInfo] = useState();
  const [deleting, setDeleting] = useState(false);
  const [snackbarState, setSnackbarState] = useState({
    open: false,
    message: '',
    severity: ''
  });

  useEffect(() => {
    setAllGyms(user?.all_gyms);
  }, [user]);

  const handleCloseModal = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setSnackbarState({
      ...snackbarState,
      open: false
    });
  };

  const getData = () => {
    dispatch(startLoading());
    getProfile(user, gymId)
      .then((res) => {
        if (res.status === CONSTANTS.STATUS_CODES.FORBIDDEN) {
          dispatch(logoutUser());
        }
        if (res.status === CONSTANTS.STATUS_CODES.SUCCESS) {
          const updatedUser = {...user , ...{all_gyms : res?.data?.all_gyms}};
          dispatch(updateUserCredentials(updatedUser));
        }
        dispatch(stopLoading());
      })
      .catch((err) => {
        dispatch(stopLoading());
        console.log(err);
      });
  };

  const onDelete = (item) => {
    dispatch(startLoading());
    setDeleting(true);
    deleteGym(user, item._id.toString())
      .then((res) => {
        if (res?.status === 200) {
          setSnackbarState({
            open: true,
            message: 'Member deleted successfully',
            severity: 'success'
          });
        } else if (res?.status !== 200) {
          setSnackbarState({
            open: true,
            message: res?.message || 'Something went wrong',
            severity: 'error'
          });
        }
        setDeleting(false);
        setDeleteModal(false);
        getData();
      })
      .catch((err) => {
        setSnackbarState({
          open: true,
          message: err?.message || 'Something went wrong',
          severity: 'error'
        });
        dispatch(stopLoading());
        setDeleting(false);
        setDeleteModal(false);
      });
  };

  const updateGymId = (id) => {
    if (id) {
      dispatch(setGymId(id));
      navigate('app/records');
    }
  };

  return (
    <>
      <Helmet>
        <title>Gyms | GMS</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.default',
          minHeight: '100%',
          py: 3
        }}
      >
        <Container maxWidth={false}>
          <Grid container spacing={2}>
            {allGyms?.length ? (
              <>
                {allGyms?.map((gym, index) => (
                  <>
                    <Grid item lg={5} key={index} sm={6} xl={5} xs={12}>
                      <div
                        onClick={() => {
                          updateGymId(gym?._id);
                        }}
                      >
                        <GymCard
                          active={gymId === gym?._id}
                          title={gym?.name}
                          imgsrc={gym?.logo}
                          email={gym?.email}
                          gym={gym}
                          setGymInfo={setGymInfo}
                          setOpen={setOpenEditModal}
                          onDelete={(item) => {
                            setGymInfo(item);
                            setDeleteModal(true);
                          }}
                        />
                      </div>
                    </Grid>
                  </>
                ))}
                <Grid item lg={5} key={'add new'} sm={6} xl={5} xs={12}>
                  <div className="addBtn" onClick={() => setOpen(true)}>
                    <AddIcon />
                  </div>
                </Grid>
              </>
            ) : (
              <div>no gym avaliable</div>
            )}
          </Grid>
        </Container>
      </Box>
      <Modal
        sx={{ overflow: 'scroll', padding: '1rem' }}
        open={open}
        onClose={handleClose}
      >
        <AddGymModal handleCloseModal={handleClose} getData={getData} />
      </Modal>
      <Modal
        sx={{ overflow: 'scroll', padding: '1rem' }}
        open={openEditModal}
        onClose={handleCloseEditModal}
      >
        <EditGymModal
          handleCloseModal={handleCloseEditModal}
          gymInfo={gymInfo}
          getData={getData}
        />
      </Modal>
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={snackbarState.open}
        autoHideDuration={3000}
        onClose={handleCloseModal}
      >
        <div>
          <Alert onClose={handleClose} severity={snackbarState.severity}>
            {snackbarState.message}
          </Alert>
        </div>
      </Snackbar>
      <ConfirmDialog
        heading={'Delete Gym'}
        message={'Do you want to delete the gym?'}
        open={deleteModal}
        handleClose={() => {
          setDeleteModal(false);
        }}
        handleConfirm={() => {
          onDelete(gymInfo);
        }}
        loading={deleting}
        key={'detete modal'}
      />
    </>
  );
};

export default Gym;
